import ThanksContent from './ThanksContent';

class PageThanks {
  constructor(mainApp) {
    console.log('PageThanks');
    this.mainApp = mainApp;
    this.content = new ThanksContent();
  }
  onLoadWindow() {}
  onWindowResize() {}
  onWindowScroll() {}
  destroy() {}
}

export default PageThanks;
